module.exports = __webpack_public_path__ + "static/media/conf-app8.90f09526.png";